import { addDeleteGetLocalStorage, storageKeys } from "../global/localData";
import { jwt_decode, redirectPage } from "./utils";

/**
 * check login or not
 */
export const checkLoginOrNot = () => {
  try {
    let token = addDeleteGetLocalStorage(storageKeys?.USER_TOKEN, {}, "get");
    let tokendata = token ? jwt_decode(token) : {};
    if (Object.keys(tokendata).length !== 0) {
      return typeof tokendata?.user?.id !== "undefined" ? true : false;
    }
  } catch (error) {
    console.error("Error in checkLoginOrNot:", error);
  }
  return false;
};
/**
 * get loggedin user data
 */
export const authData = () => {
  try {
    let token = addDeleteGetLocalStorage(storageKeys?.USER_TOKEN, {}, "get");
    let tokendata = token ? jwt_decode(token) : { id: 0 };
    if (Object.keys(tokendata).length !== 0) {
      return typeof tokendata?.user?.id !== "undefined" ? tokendata : { id: 0 };
    }
    return tokendata;
  } catch (error) {
    redirectPage("/");
  }
};
